import React, { useState } from "react";
//import { renderCount } from '../../../../appHelpers/appLoggers';
import { Message, useToaster } from "rsuite";
import { Form as RSuiteForm } from "rsuite";
import axiosInstance from "../../../../../../appHelpers/axiosInstance";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Modal } from "../../../../../ui";

export const OverrideSystem = ({ system }) => {
  const { getAccessTokenSilently } = useAuth0();
  const toaster = useToaster();
  const initFormSite = {
    id: system.id,
    site_id: system.site_id,
    cus_sys_id: system.cus_sys_id,
    room: system.room,
    model: system.model,
    serial_number: system.serial_number,
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open, setOpen] = useState(false);
  const [formValue, setFormValue] = useState(initFormSite);
  const [loading, setLoading] = useState(false);
  const message = (
    <Message showIcon type="success" header="Success">
      You successfully updated {system?.id}.
    </Message>
  );

  const onSubmit = async () => {
    setLoading(true);
    try {
      const token = await getAccessTokenSilently({
        audience: `${process.env.REACT_APP_AUTH0_EXPRESS_API}`,
      });

      const response = await axiosInstance({
        method: "POST",
        url: `/customer/update/system/`,
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${token}`,
        },
        data: JSON.stringify({
          customer_id: system.customer_id,
          system: formValue,
        }),
      });
      // setResMsg(response.data);
      toaster.push(message, "topCenter");
      handleClose();
    } catch (error) {
      console.error(error);
      toaster.push(errMessage, "topCenter");
    } finally {
      setLoading(false);
    }
  };

  const footerActions = (
    <>
      <Button variant="subtle" onClick={handleClose} disabled={loading}>
        Cancel
      </Button>
      <Button variant="primary" onClick={onSubmit} loading={loading}>
        Submit
      </Button>
    </>
  );

  return (
    <>
      <Button variant="outline" size="small" onClick={handleOpen}>
        Override
      </Button>
      <Modal
        title={`Edit System: ${system?.id}`}
        size="xs"
        open={open}
        onClose={handleClose}
        showFooter={true}
        footerActions={footerActions}
        loading={loading}
      >
        <RSuiteForm
          fluid
          formValue={formValue}
          onChange={(formValue) => setFormValue(formValue)}
        >
          <RSuiteForm.Group controlId="id">
            <RSuiteForm.ControlLabel>ID</RSuiteForm.ControlLabel>
            <RSuiteForm.Control name="id" readOnly disabled />
          </RSuiteForm.Group>
          <RSuiteForm.Group controlId="site_id">
            <RSuiteForm.ControlLabel>Site</RSuiteForm.ControlLabel>
            <RSuiteForm.Control name="site_id" readOnly disabled />
          </RSuiteForm.Group>
          <RSuiteForm.Group controlId="cus_sys_id">
            <RSuiteForm.ControlLabel>CUID</RSuiteForm.ControlLabel>
            <RSuiteForm.Control name="cus_sys_id" />
          </RSuiteForm.Group>
          <RSuiteForm.Group controlId="room">
            <RSuiteForm.ControlLabel>Room</RSuiteForm.ControlLabel>
            <RSuiteForm.Control name="room" />
          </RSuiteForm.Group>
          <RSuiteForm.Group controlId="model">
            <RSuiteForm.ControlLabel>Model</RSuiteForm.ControlLabel>
            <RSuiteForm.Control name="model" />
          </RSuiteForm.Group>
          <RSuiteForm.Group controlId="serial_number">
            <RSuiteForm.ControlLabel>Serial Number</RSuiteForm.ControlLabel>
            <RSuiteForm.Control name="serial_number" />
          </RSuiteForm.Group>
        </RSuiteForm>
      </Modal>
    </>
  );
};

const errMessage = (
  <Message showIcon type="error" header="Error">
    Something went wrong. Please try again.
  </Message>
);
